export default __webpack_public_path__ + "static/media/imageProfile.54f2898d.svg";